document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const initMobileNavPortal = () => {
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (!mobileNav || mobileNav.dataset.portaled === 'true') return;
  if (mobileNav.closest('#site-top')) {
    const anchor = document.querySelector('[data-cart-drawer]') || document.getElementById('MainContent');
    document.body.insertBefore(mobileNav, anchor);
    mobileNav.dataset.portaled = 'true';
  }
};

const mobileMedia = window.matchMedia('(max-width: 920px)');

const getCartDrawer = () => document.querySelector('[data-cart-drawer]');
const getMobileNav = () => document.querySelector('[data-mobile-nav]');

const setMenuOpen = (open) => {
  document.body.classList.toggle('menu-open', open);
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = getMobileNav();
  if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  if (nav) nav.setAttribute('aria-hidden', open ? 'false' : 'true');
  if (open) {
    setCartOpen(false);
    setSearchOpen(false);
  }
};

const setCartOpen = (open) => {
  const drawer = getCartDrawer();
  document.body.classList.toggle('cart-open', open);
  if (!drawer) return;
  drawer.classList.toggle('is-open', open);
  drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
  const toggle = document.querySelector('[data-cart-toggle]');
  if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  if (open) {
    setMenuOpen(false);
    document.body.classList.remove('drawer-open');
    setSearchOpen(false);
    const promoDrawer = document.querySelector('[data-promo-drawer]');
    if (promoDrawer) {
      promoDrawer.classList.remove('is-open');
      promoDrawer.setAttribute('aria-hidden', 'true');
    }
  }
};

const setSearchOpen = (open) => {
  const drawer = document.querySelector('[data-search-drawer]');
  document.body.classList.toggle('search-open', open);
  if (!drawer) return;
  drawer.classList.toggle('is-open', open);
  drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
  document.querySelectorAll('[data-search-toggle]').forEach((el) => {
    if (el.tagName === 'BUTTON') el.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  if (open) {
    setMenuOpen(false);
    setCartOpen(false);
    setPromoOpen(false);
    window.requestAnimationFrame(() => {
      drawer.querySelector('[data-search-input]')?.focus();
    });
  }
};

const setPromoOpen = (open) => {
  const drawer = document.querySelector('[data-promo-drawer]');
  if (!drawer) return;
  drawer.classList.toggle('is-open', open);
  drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
  document.body.classList.toggle('drawer-open', open);
  if (open) {
    setMenuOpen(false);
    setCartOpen(false);
    setSearchOpen(false);
  }
};

const updateCartCount = (count) => {
  document.querySelectorAll('[data-cart-count]').forEach((badge) => {
    badge.textContent = String(count);
    badge.hidden = count <= 0;
  });
};

const updateCartDrawerMeta = (cart) => {
  const countEl = document.querySelector('[data-cart-drawer-count]');
  if (!countEl) return;
  if (cart.item_count === 0) {
    countEl.textContent = 'Your bag is empty';
  } else if (cart.item_count === 1) {
    countEl.textContent = '1 item';
  } else {
    countEl.textContent = `${cart.item_count} items`;
  }
};

const refreshCartDrawer = async () => {
  const drawerBody = document.querySelector('[data-cart-drawer-body]');
  if (!drawerBody) return null;

  const root = window.Shopify?.routes?.root || '/';
  const sectionId = getCartDrawerSectionId();
  const response = await fetch(`${root}?sections=${encodeURIComponent(sectionId)}`);
  if (!response.ok) return null;
  const sections = await response.json();
  const html = sections[sectionId] || sections['cart-drawer'];
  if (!html) return null;

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const nextBody = doc.querySelector('[data-cart-drawer-body]');
  if (nextBody) drawerBody.innerHTML = nextBody.innerHTML;

  const cartResponse = await fetch('/cart.js');
  if (!cartResponse.ok) return null;
  const cart = await cartResponse.json();
  updateCartCount(cart.item_count);
  updateCartDrawerMeta(cart);
  return cart;
};

const changeCartLine = async (line, quantity) => {
  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ line, quantity }),
  });
  if (!response.ok) return;
  await refreshCartDrawer();
};

const updateCartNote = async (note) => {
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ note }),
  });
};

let cartNoteTimer;
document.addEventListener('click', (event) => {
  const menuToggle = event.target.closest('[data-menu-toggle]');
  if (menuToggle) {
    setMenuOpen(!document.body.classList.contains('menu-open'));
    return;
  }

  const searchToggle = event.target.closest('[data-search-toggle]');
  if (searchToggle) {
    event.preventDefault();
    const drawer = document.querySelector('[data-search-drawer]');
    if (drawer) setSearchOpen(!drawer.classList.contains('is-open'));
    return;
  }

  const cartToggle = event.target.closest('[data-cart-toggle]');
  if (cartToggle) {
    event.preventDefault();
    const willOpen = !getCartDrawer()?.classList.contains('is-open');
    if (willOpen) {
      refreshCartDrawer().finally(() => setCartOpen(true));
    } else {
      setCartOpen(false);
    }
    return;
  }

  const megaParent = event.target.closest('.has-mega');
  const megaLink = event.target.closest('.primary-nav--mobile .has-mega > .nav-list__link, .primary-nav--mobile .has-mega > a');
  if (megaLink && mobileMedia.matches) {
    const parent = megaLink.closest('.has-mega');
    if (parent && !parent.classList.contains('is-open')) {
      event.preventDefault();
      document.querySelectorAll('.primary-nav--mobile .has-mega.is-open').forEach((item) => {
        if (item !== parent) item.classList.remove('is-open');
      });
      parent.classList.add('is-open');
      return;
    }
  }

  if (!megaParent && !menuToggle) {
    document.querySelectorAll('.primary-nav--mobile .has-mega.is-open').forEach((item) => item.classList.remove('is-open'));
  }

  const mobileNavLink = event.target.closest('.primary-nav--mobile a');
  if (mobileNavLink && mobileMedia.matches && !mobileNavLink.closest('.has-mega > .nav-list__link')) {
    setMenuOpen(false);
  }

  const mobileSearch = event.target.closest('.mobile-nav__secondary[data-search-toggle]');
  if (mobileSearch && mobileMedia.matches) {
    setMenuOpen(false);
  }

  const promoToggle = event.target.closest('[data-promo-toggle]');
  if (promoToggle) {
    const drawer = document.querySelector('[data-promo-drawer]');
    if (drawer) setPromoOpen(!drawer.classList.contains('is-open'));
    return;
  }

  const cartQtyBtn = event.target.closest('[data-cart-qty-minus], [data-cart-qty-plus]');
  if (cartQtyBtn) {
    const line = Number(cartQtyBtn.getAttribute('data-line'));
    const item = cartQtyBtn.closest('[data-cart-item]');
    const valueEl = item?.querySelector('[data-cart-qty-value]');
    const current = Math.max(0, Number.parseInt(valueEl?.textContent, 10) || 0);
    const nextQty = Math.max(0, current + (cartQtyBtn.hasAttribute('data-cart-qty-plus') ? 1 : -1));
    if (line) changeCartLine(line, nextQty);
    return;
  }

  const removeBtn = event.target.closest('[data-cart-remove]');
  if (removeBtn) {
    const line = Number(removeBtn.getAttribute('data-line'));
    if (line) changeCartLine(line, 0);
    return;
  }

  const beforeAfterTab = event.target.closest('[data-ba-tab]');
  if (beforeAfterTab) {
    const id = beforeAfterTab.getAttribute('data-ba-tab');
    const scope = beforeAfterTab.closest('.before-after');
    if (scope) {
      scope.querySelectorAll('[data-ba-tab]').forEach((tab) => tab.classList.toggle('is-active', tab === beforeAfterTab));
      scope.querySelectorAll('[data-ba-panel]').forEach((panel) => panel.classList.toggle('is-hidden', panel.getAttribute('data-ba-panel') !== id));
    }
  }

  const stickyAdd = event.target.closest('[data-sticky-add]');
  if (stickyAdd) {
    const form = document.querySelector('[data-product-form]');
    const submit = form?.querySelector('[data-add-button]');
    if (submit && !submit.disabled) submit.click();
  }

  const qtyMinus = event.target.closest('[data-qty-minus]');
  const qtyPlus = event.target.closest('[data-qty-plus]');
  if (qtyMinus || qtyPlus) {
    const wrap = event.target.closest('[data-qty]');
    const input = wrap?.querySelector('[data-qty-input]');
    if (!input) return;
    const current = Math.max(1, Number.parseInt(input.value, 10) || 1);
    input.value = String(Math.max(1, current + (qtyPlus ? 1 : -1)));
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  setMenuOpen(false);
  setCartOpen(false);
  setSearchOpen(false);
  setPromoOpen(false);
  document.querySelectorAll('.primary-nav--mobile .has-mega.is-open').forEach((item) => item.classList.remove('is-open'));
});

document.addEventListener('input', (event) => {
  const noteField = event.target.closest('[data-cart-note]');
  if (!noteField) return;
  clearTimeout(cartNoteTimer);
  cartNoteTimer = setTimeout(() => {
    updateCartNote(noteField.value);
  }, 400);
});

const readProductVariants = (form) => {
  const variantsScript = form.querySelector('[data-product-variants]');
  if (!variantsScript) return [];

  try {
    return JSON.parse(variantsScript.textContent);
  } catch (error) {
    return [];
  }
};

const getSelectedOptions = (form) => {
  return Array.from(form.querySelectorAll('.pdp-option')).map((fieldset) => {
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : '';
  });
};

const formatMoney = (cents, format) => {
  if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, format);
  const amount = (cents / 100).toFixed(2);
  if (!format) return amount;
  return format
    .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
    .replace('{{amount_no_decimals}}', String(Math.round(cents / 100)))
    .replace('{{amount}}', amount);
};

const getFormVariant = (form, variants) => {
  if (!variants.length) return null;

  const field = form.querySelector('[data-variant-select]');
  if (!field) return null;

  if (field.tagName === 'SELECT') {
    const selectedOptions = getSelectedOptions(form);
    if (selectedOptions.some(Boolean)) {
      const matched = variants.find((variant) =>
        selectedOptions.every((value, index) => !value || variant.options[index] === value)
      );
      if (matched) return matched;
    }
  }

  const variantId = field.value;
  if (variantId) {
    const matched = variants.find((variant) => String(variant.id) === String(variantId));
    if (matched) return matched;
  }

  return variants.find((variant) => variant.available) || variants[0] || null;
};

const getCartDrawerSectionId = () => {
  const drawer = getCartDrawer();
  const sectionEl = drawer?.closest('.shopify-section, [id^="shopify-section-"]');
  if (sectionEl?.id) {
    return sectionEl.id.replace('shopify-section-', '');
  }
  return 'cart-drawer';
};

const getActiveBundleTier = (form) => {
  const bundle = form.closest('.pdp')?.querySelector('[data-pdp-bundle]');
  if (!bundle) return null;
  const checked = bundle.querySelector('[data-bundle-input]:checked');
  if (!checked) return null;
  const tier = checked.closest('[data-bundle-tier]');
  if (!tier) return null;
  return {
    quantity: Number(tier.dataset.quantity || 1),
    discountPercent: Number(tier.dataset.discountPercent || 0),
    discountCode: tier.dataset.discountCode || '',
    label: tier.dataset.tierLabel || tier.dataset.quantity || '1',
  };
};

const calculateBundlePricing = (unitCents, tier) => {
  const quantity = tier.quantity;
  const subtotal = unitCents * quantity;
  const discount = Math.round(subtotal * (tier.discountPercent / 100));
  const total = subtotal - discount;
  const each = quantity > 0 ? Math.round(total / quantity) : unitCents;
  return { quantity, subtotal, discount, total, each };
};

const applySelectedBundleTier = (form, variant) => {
  const bundle = form.closest('.pdp')?.querySelector('[data-pdp-bundle]');
  const tier = getActiveBundleTier(form);
  const qtyInput = form.querySelector('[data-qty-input]');
  if (!bundle || !tier || !variant || !qtyInput) return false;

  qtyInput.value = String(tier.quantity);
  const pricing = calculateBundlePricing(variant.price, tier);
  const moneyFormat = bundle.dataset.moneyFormat || '${{amount}}';
  const totalFormatted = formatMoney(pricing.total, moneyFormat);
  const compareFormatted = formatMoney(pricing.subtotal, moneyFormat);

  form.closest('.pdp')?.querySelectorAll('[data-product-price]').forEach((target) => {
    target.textContent = totalFormatted;
  });
  const priceButton = form.querySelector('[data-product-price-button]');
  if (priceButton) priceButton.textContent = totalFormatted;
  const stickyPrice = document.querySelector('[data-sticky-price]');
  if (stickyPrice) stickyPrice.textContent = totalFormatted;

  const compareTarget = form.closest('.pdp')?.querySelector('[data-product-compare]');
  if (compareTarget) {
    if (pricing.discount > 0) {
      compareTarget.textContent = compareFormatted;
      compareTarget.hidden = false;
    } else if (variant.compare_at_price > variant.price) {
      compareTarget.textContent = formatMoney(variant.compare_at_price, moneyFormat);
      compareTarget.hidden = false;
    } else {
      compareTarget.hidden = true;
    }
  }

  return true;
};

const updateBundleDisplay = (form, variant) => {
  const bundle = form.closest('.pdp')?.querySelector('[data-pdp-bundle]');
  if (!bundle || !variant) return;

  const moneyFormat = bundle.dataset.moneyFormat || '${{amount}}';
  const saveLabel = bundle.closest('.pdp-buybox')?.querySelector('.pdp-bundle__heading')?.textContent ? 'Save' : 'Save';

  bundle.querySelectorAll('[data-bundle-tier]').forEach((tierEl) => {
    const tier = {
      quantity: Number(tierEl.dataset.quantity || 1),
      discountPercent: Number(tierEl.dataset.discountPercent || 0),
    };
    const pricing = calculateBundlePricing(variant.price, tier);
    const eachEl = tierEl.querySelector('[data-bundle-each]');
    const totalEl = tierEl.querySelector('[data-bundle-total]');
    const saveEl = tierEl.querySelector('[data-bundle-save]');
    if (eachEl) eachEl.textContent = formatMoney(pricing.each, moneyFormat);
    if (totalEl) totalEl.textContent = formatMoney(pricing.total, moneyFormat);
    if (saveEl && pricing.discount > 0) {
      saveEl.textContent = `Save ${formatMoney(pricing.discount, moneyFormat)}`;
    }
  });

  applySelectedBundleTier(form, variant);
};

const scrollToVariantMedia = (form, variant) => {
  const mediaId = variant?.featured_media?.id || variant?.featured_image?.id;
  if (!mediaId) return;

  const gallery = document.querySelector('[data-pdp-gallery]');
  const target = gallery?.querySelector(`[data-media-id="${mediaId}"]`);
  if (!target || !gallery) return;

  const index = Number(target.getAttribute('data-slide-index') || 0);
  goToPdpSlide(gallery, index);
};

const setProductButtonState = (form, variant, state = 'available') => {
  const button = form.querySelector('[data-add-button]');
  if (!button) return;

  const label = form.querySelector('[data-add-label]');
  const priceTargets = form.closest('.pdp')?.querySelectorAll('[data-product-price]') || [];
  const priceButton = form.querySelector('[data-product-price-button]');
  const compareTarget = form.closest('.pdp')?.querySelector('[data-product-compare]');
  const stickyPrice = document.querySelector('[data-sticky-price]');
  const stickyAdd = document.querySelector('[data-sticky-add]');
  const availableLabel = button.getAttribute('data-available-label') || 'Add to cart';
  const soldOutLabel = button.getAttribute('data-soldout-label') || 'Sold out';
  const unavailableLabel = button.getAttribute('data-unavailable-label') || 'Unavailable';
  const selectedOption = variant ? form.querySelector(`[data-variant-select] option[value="${variant.id}"]`) : null;
  let price = selectedOption ? selectedOption.getAttribute('data-price') : '';
  let compareAt = selectedOption ? selectedOption.getAttribute('data-compare-at') : '';
  if (!price && variant) {
    const moneyFormat = form.closest('.pdp')?.querySelector('[data-pdp-bundle]')?.dataset.moneyFormat;
    price = formatMoney(variant.price, moneyFormat);
    if (variant.compare_at_price > variant.price) {
      compareAt = formatMoney(variant.compare_at_price, moneyFormat);
    }
  }

  if (price) {
    const bundleApplied = applySelectedBundleTier(form, variant);
    if (!bundleApplied) {
      priceTargets.forEach((target) => {
        target.textContent = price;
      });
      if (priceButton) priceButton.textContent = price;
      if (stickyPrice) stickyPrice.textContent = price;
    }
  }
  if (compareTarget) {
    if (compareAt) {
      compareTarget.textContent = compareAt;
      compareTarget.hidden = false;
    } else {
      compareTarget.hidden = true;
    }
  }

  const isAvailable = state === 'available' && variant && variant.available;
  button.disabled = !isAvailable;
  button.classList.toggle('is-disabled', !isAvailable);
  if (stickyAdd) stickyAdd.disabled = !isAvailable;
  if (label) {
    label.textContent = state === 'unavailable' ? unavailableLabel : (isAvailable ? availableLabel : soldOutLabel);
  }
};

const refreshOptionAvailability = (form, variants) => {
  const selectedOptions = getSelectedOptions(form);
  const optionGroups = Array.from(form.querySelectorAll('.pdp-option'));

  optionGroups.forEach((fieldset, optionIndex) => {
    fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
      const candidateOptions = [...selectedOptions];
      candidateOptions[optionIndex] = input.value;
      const canBuy = variants.some((variant) => {
        return variant.available && candidateOptions.every((value, index) => !value || variant.options[index] === value);
      });
      const label = input.closest('.pdp-swatch');
      input.disabled = !canBuy && !input.checked;
      if (label) {
        label.classList.toggle('is-unavailable', !canBuy);
        label.setAttribute('aria-disabled', canBuy ? 'false' : 'true');
      }
    });
  });
};

const updateProductForm = (form) => {
  const variants = readProductVariants(form);
  if (!variants.length) return;

  const select = form.querySelector('[data-variant-select]');
  if (!select || select.tagName !== 'SELECT') {
    const matchedVariant = getFormVariant(form, variants);
    if (!matchedVariant) return;
    setProductButtonState(form, matchedVariant, matchedVariant.available ? 'available' : 'soldout');
    updateBundleDisplay(form, matchedVariant);
    return;
  }

  const selectedOptions = getSelectedOptions(form);
  const matchedVariant = variants.find((variant) => {
    return selectedOptions.every((value, index) => variant.options[index] === value);
  });

  refreshOptionAvailability(form, variants);

  if (!matchedVariant) {
    setProductButtonState(form, null, 'unavailable');
    return;
  }

  select.value = String(matchedVariant.id);
  setProductButtonState(form, matchedVariant, matchedVariant.available ? 'available' : 'soldout');
  updateBundleDisplay(form, matchedVariant);
  scrollToVariantMedia(form, matchedVariant);
};

const applyDiscountCode = async (code) => {
  if (!code) return;
  await fetch(`/discount/${encodeURIComponent(code)}`, {
    method: 'GET',
    credentials: 'same-origin',
  });
};

const handleProductFormSubmit = async (event) => {
  const form = event.currentTarget?.matches?.('[data-product-form]')
    ? event.currentTarget
    : event.target.closest('[data-product-form]');
  if (!form || form.dataset.ajaxCart !== 'true') return;

  event.preventDefault();
  const button = form.querySelector('[data-add-button]');
  if (button?.disabled) return;

  const variants = readProductVariants(form);
  const variant = getFormVariant(form, variants);
  if (!variant) return;

  const tier = getActiveBundleTier(form);
  const qtyInput = form.querySelector('[data-qty-input]');
  const quantity = Number(qtyInput?.value || 1);
  const properties = {};

  if (tier) {
    properties._bundle_tier = tier.label;
    properties._bundle_qty = String(tier.quantity);
    if (tier.discountPercent > 0) properties._bundle_discount = `${tier.discountPercent}%`;
  }

  const root = window.Shopify?.routes?.root || '/';
  button.disabled = true;
  try {
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: Number(variant.id),
          quantity: Math.max(1, quantity),
          properties,
        }],
      }),
    });

    if (!response.ok) {
      let message = 'Add to cart failed';
      try {
        const errorBody = await response.json();
        if (errorBody?.description) message = errorBody.description;
        else if (errorBody?.message) message = errorBody.message;
      } catch (parseError) {
        /* ignore */
      }
      throw new Error(message);
    }

    await response.json();

    if (tier?.discountCode) {
      try {
        await applyDiscountCode(tier.discountCode);
      } catch (discountError) {
        /* discount codes are optional; do not block the drawer */
      }
    }

    const afterAdd = form.dataset.afterAdd || 'drawer';
    if (afterAdd === 'checkout') {
      window.location.href = `${root}checkout`;
      return;
    }
    if (afterAdd === 'cart') {
      window.location.href = `${root}cart`;
      return;
    }

    await refreshCartDrawer();
    updateCartCount((await fetch(`${root}cart.js`).then((res) => res.json())).item_count);

    if (afterAdd !== 'stay') {
      setCartOpen(true);
    }

    button.disabled = !variant.available;
  } catch (error) {
    button.disabled = !variant.available;
    if (window.console?.error) console.error(error);
  }
};

const initBundleSale = () => {
  document.querySelectorAll('[data-pdp-bundle]').forEach((bundle) => {
    if (bundle.dataset.bundleUiReady === 'true') return;
    bundle.dataset.bundleUiReady = 'true';
    const form = bundle.closest('.pdp')?.querySelector('[data-product-form]');
    if (!form) return;

    bundle.addEventListener('change', (event) => {
      if (!event.target.matches('[data-bundle-input]')) return;
      const variants = readProductVariants(form);
      const variant = getFormVariant(form, variants);
      if (variant) applySelectedBundleTier(form, variant);
    });

    const actions = form.querySelector('[data-pdp-actions]');
    if (actions && !form.querySelector('[data-qty]:not([type="hidden"])')) {
      actions.classList.add('pdp-buybox__actions--bundle-only');
    }
  });

  document.querySelectorAll('[data-product-form][data-ajax-cart="true"]').forEach((form) => {
    if (form.dataset.submitReady === 'true') return;
    form.dataset.submitReady = 'true';
    form.addEventListener('submit', handleProductFormSubmit);
  });
};

const goToPdpSlide = (gallery, index) => {
  const track = gallery.querySelector('[data-pdp-gallery-track]');
  const slides = track ? [...track.querySelectorAll('.pdp-gallery__slide')] : [];
  if (!track || !slides[index]) return;

  const left = slides[index].offsetLeft;
  track.scrollTo({ left, behavior: mobileMedia.matches ? 'smooth' : 'auto' });
  syncPdpGalleryState(gallery, index);
};

const syncPdpGalleryState = (gallery, index) => {
  gallery.querySelectorAll('[data-pdp-thumb]').forEach((thumb, thumbIndex) => {
    thumb.classList.toggle('is-active', thumbIndex === index);
  });
  gallery.querySelectorAll('[data-pdp-gallery-dot]').forEach((dot, dotIndex) => {
    dot.classList.toggle('is-active', dotIndex === index);
  });
};

const initPdpGallery = () => {
  document.querySelectorAll('[data-pdp-gallery]').forEach((gallery) => {
    if (gallery.dataset.galleryReady === 'true') return;
    gallery.dataset.galleryReady = 'true';

    const track = gallery.querySelector('[data-pdp-gallery-track]');
    const slides = track ? [...track.querySelectorAll('.pdp-gallery__slide')] : [];
    if (!track || slides.length <= 1) return;

    const getActiveIndex = () => {
      const width = track.clientWidth || 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
    };

    track.addEventListener('scroll', () => {
      syncPdpGalleryState(gallery, getActiveIndex());
    }, { passive: true });

    let touchStartX = 0;
    let touchStartY = 0;
    let touchAxis = null;

    track.addEventListener('touchstart', (event) => {
      if (!event.touches[0]) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      touchAxis = null;
    }, { passive: true });

    track.addEventListener('touchmove', (event) => {
      if (!event.touches[0]) return;
      const deltaX = Math.abs(event.touches[0].clientX - touchStartX);
      const deltaY = Math.abs(event.touches[0].clientY - touchStartY);
      if (touchAxis == null && (deltaX > 8 || deltaY > 8)) {
        touchAxis = deltaX > deltaY ? 'x' : 'y';
      }
      if (touchAxis === 'x') {
        track.classList.add('is-dragging');
      }
    }, { passive: true });

    track.addEventListener('touchend', () => {
      track.classList.remove('is-dragging');
      syncPdpGalleryState(gallery, getActiveIndex());
      touchAxis = null;
    }, { passive: true });

    let dragStartX = 0;
    let dragStartScroll = 0;
    let isDragging = false;

    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch') return;
      isDragging = true;
      dragStartX = event.clientX;
      dragStartScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      track.setPointerCapture?.(event.pointerId);
    });

    track.addEventListener('pointermove', (event) => {
      if (!isDragging) return;
      track.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
    });

    const endDrag = (event) => {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      track.releasePointerCapture?.(event.pointerId);
      syncPdpGalleryState(gallery, getActiveIndex());
    };

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    gallery.querySelector('[data-pdp-gallery-prev]')?.addEventListener('click', () => {
      const nextIndex = Math.max(0, getActiveIndex() - 1);
      goToPdpSlide(gallery, nextIndex);
    });

    gallery.querySelector('[data-pdp-gallery-next]')?.addEventListener('click', () => {
      const nextIndex = Math.min(slides.length - 1, getActiveIndex() + 1);
      goToPdpSlide(gallery, nextIndex);
    });

    gallery.querySelectorAll('[data-pdp-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        goToPdpSlide(gallery, Number(thumb.getAttribute('data-pdp-thumb') || 0));
      });
    });

    gallery.querySelectorAll('[data-pdp-gallery-dot]').forEach((dot) => {
      dot.addEventListener('click', () => {
        goToPdpSlide(gallery, Number(dot.getAttribute('data-pdp-gallery-dot') || 0));
      });
    });
  });
};

const initStickyProductBar = () => {
  const actions = document.querySelector('[data-pdp-actions]');
  const sticky = document.querySelector('[data-pdp-sticky]');
  if (!actions || !sticky || !mobileMedia.matches) {
    if (sticky) sticky.hidden = true;
    return;
  }

  const toggleSticky = (visible) => {
    sticky.hidden = !visible;
    document.body.classList.toggle('pdp-sticky-visible', visible);
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      toggleSticky(!entries[0].isIntersecting);
    }, { threshold: 0, rootMargin: '0px 0px -1px 0px' });
    observer.observe(actions);
  }
};

const initProductRecommendations = () => {
  document.querySelectorAll('[data-product-recommendations]').forEach((section) => {
    const url = section.getAttribute('data-url');
    const target = section.querySelector('[data-recommendations-results]');
    if (!url || !target) return;

    const loadRecommendations = () => {
      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const nextResults = doc.querySelector('[data-recommendations-results]');
          if (nextResults && nextResults.innerHTML.trim()) {
            target.innerHTML = nextResults.innerHTML;
          }
        })
        .catch(() => {});
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        loadRecommendations();
      }, { rootMargin: '0px 0px 240px 0px' });
      observer.observe(section);
    } else {
      loadRecommendations();
    }
  });
};

const initStickyHeader = () => {
  const siteTop = document.getElementById('site-top');
  const header = siteTop?.querySelector('.site-header');
  if (!siteTop || !header) return;

  const enabled = header.dataset.enableSticky !== 'false';
  siteTop.classList.toggle('site-top--sticky', enabled);

  const syncTopHeight = () => {
    const height = siteTop.offsetHeight;
    document.documentElement.style.setProperty('--site-top-height', `${height}px`);
  };

  const syncScrollState = () => {
    siteTop.classList.toggle('is-scrolled', window.scrollY > 6);
  };

  syncTopHeight();
  syncScrollState();
};

if (!window.__miradaStickyHeaderBound) {
  window.__miradaStickyHeaderBound = true;
  window.addEventListener('scroll', () => {
    document.getElementById('site-top')?.classList.toggle('is-scrolled', window.scrollY > 6);
  }, { passive: true });
  window.addEventListener('resize', () => {
    initStickyHeader();
  });
  mobileMedia.addEventListener('change', () => {
  initStickyHeader();
  syncFooterAccordions();
});
}

const initScrollRows = () => {
  document.querySelectorAll('[data-scroll-row]').forEach((row) => {
    if (row.dataset.scrollReady === 'true') return;
    row.dataset.scrollReady = 'true';
    row.setAttribute('tabindex', '0');
    row.setAttribute('role', 'region');
    row.setAttribute('aria-label', row.getAttribute('data-scroll-label') || 'Product carousel');

    const wrap = row.closest('[data-scroll-row-wrap]');
    if (!wrap) return;

    const syncScrollHint = () => {
      const atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 8;
      wrap.classList.toggle('is-at-end', atEnd);
      wrap.classList.toggle('is-empty', row.scrollWidth <= row.clientWidth + 1);
    };

    syncScrollHint();
    row.addEventListener('scroll', syncScrollHint, { passive: true });
    window.addEventListener('resize', syncScrollHint);
  });
};

document.addEventListener('change', (event) => {
  const optionInput = event.target.closest('.pdp-option input[type="radio"]');
  if (!optionInput) return;

  const form = optionInput.closest('[data-product-form]');
  if (form) updateProductForm(form);
});

const initProductPage = () => {
  document.querySelectorAll('[data-product-form]').forEach(updateProductForm);
  initBundleSale();
  initPdpGallery();
  initStickyProductBar();
  initProductRecommendations();
  initScrollRows();
};

const syncFooterAccordions = () => {
  document.querySelectorAll('.footer-column').forEach((column) => {
    if (mobileMedia.matches) {
      column.removeAttribute('open');
    } else {
      column.setAttribute('open', '');
    }
  });
};

initMobileNavPortal();
initStickyHeader();
initProductPage();
syncFooterAccordions();

document.addEventListener('shopify:section:load', () => {
  setMenuOpen(false);
  setCartOpen(false);
  setSearchOpen(false);
  setPromoOpen(false);
  document.querySelectorAll('.primary-nav--mobile .has-mega.is-open').forEach((item) => item.classList.remove('is-open'));
  initMobileNavPortal();
  initStickyHeader();
  initProductPage();
  syncFooterAccordions();
});

mobileMedia.addEventListener('change', initStickyProductBar);
